var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.653 20.784C25.713 19.003 27 16.963 27 16c0-1.91-5.02-8-11.098-8-1.456 0-2.846.358-4.118.927L14.2 11.34a4.952 4.952 0 0 1 1.808-.34C18.736 11 21 13.258 21 16.012c0 .627-.12 1.23-.337 1.785zM11.346 14.189A4.964 4.964 0 0 0 11 16.012C11 18.742 13.256 21 16.008 21c.637 0 1.248-.123 1.812-.346l2.372 2.369c-1.323.598-2.773.977-4.29.977C9.895 24 5 17.901 5 16c0-.976 1.276-3.04 3.325-4.828z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.384 27.723c.37.37.973.37 1.343 0 .358-.382.37-.973 0-1.342L5.62 4.277a.961.961 0 0 0-1.351 0c-.359.37-.359.985 0 1.342z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDisabled);
export default __webpack_public_path__ + "static/media/Eye_Disabled.e1a8c204c5fbad98d1cc4d53ddb0e8f9.svg";
export { ForwardRef as ReactComponent };